import { useRequiredContext } from "@redotech/react-util/context";
import CodeBrowserIcon from "@redotech/redo-icons/code-browser.svg";
import CodeBrowserFilledIcon from "@redotech/redo-icons/code-browser_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { isAdvancedCheckoutFeaturesAvailable } from "@redotech/redo-model/conversion/features";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const WidgetsItems = memo(function WidgetsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_WIDGETS,
  );

  const isAvailable = isAdvancedCheckoutFeaturesAvailable({
    hasShopifyPlus: !!team.shopifyIntegration?.hasShopifyPlus,
    planDisplayName: team.shopifyIntegration?.planDisplayName,
    teamId: team._id,
  });

  if (!isAvailable) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : { type: "link", href: routes.getConversionSubRoute("widgets") }
      }
      dimmed={locked}
      FilledIcon={CodeBrowserFilledIcon}
      friendlyName="Widgets"
      id="widgets"
      isPrivate={locked}
      UnfilledIcon={CodeBrowserIcon}
    />
  );
});
